export default __webpack_public_path__ + "static/media/varexe-farsi-logo.695fcffb.svg";